import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

// Icon types with their colors
const getIconForCategory = (category, isSelected = false) => {
  const iconColors = {
    'Mammalia': '#DC143C', // red
    'Aves': '#00008B', // dark blue
    'Actinopterygii': '#87CEEB', // light blue
    'Insecta': '#9370DB', // purple
    'Reptilia': '#FF8C00', // orange
    'Plantae': '#228B22' // green
  };

  const iconSymbols = {
    'Mammalia': '🐱',
    'Aves': '🐦',
    'Actinopterygii': '🐟',
    'Insecta': '🐛',
    'Reptilia': '🐢',
    'Plantae': '🌿'
  };

  const color = iconColors[category] || '#808080';
  const symbol = iconSymbols[category] || '●';
  const size = isSelected ? 40 : 30;
  // Outer size includes the glow ring for selected pins
  const outerSize = isSelected ? 56 : 30;
  const offset = (outerSize - size) / 2;

  let svgIcon;
  if (isSelected) {
    svgIcon = `
      <svg width="${outerSize}" height="${outerSize}" xmlns="http://www.w3.org/2000/svg">
        <style>
          @keyframes pulse-ring {
            0% { opacity: 0.6; r: ${outerSize / 2 - 4}; }
            50% { opacity: 0.2; r: ${outerSize / 2 - 1}; }
            100% { opacity: 0.6; r: ${outerSize / 2 - 4}; }
          }
          .glow-ring { animation: pulse-ring 1.5s ease-in-out infinite; }
        </style>
        <circle class="glow-ring" cx="${outerSize/2}" cy="${outerSize/2}" r="${outerSize/2 - 4}" fill="none" stroke="#FFD700" stroke-width="3"/>
        <circle cx="${outerSize/2}" cy="${outerSize/2}" r="${size/2 - 2}" fill="${color}" stroke="#FFD700" stroke-width="3"/>
        <text x="${outerSize/2}" y="${outerSize/2}" text-anchor="middle" dy=".3em" font-size="18" fill="white">${symbol}</text>
      </svg>
    `;
  } else {
    svgIcon = `
      <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${size/2}" cy="${size/2}" r="${size/2 - 2}" fill="${color}" stroke="none" stroke-width="0"/>
        <text x="${size/2}" y="${size/2}" text-anchor="middle" dy=".3em" font-size="16" fill="white">${symbol}</text>
      </svg>
    `;
  }

  return L.divIcon({
    html: svgIcon,
    className: 'species-marker-icon',
    iconSize: [isSelected ? outerSize : size, isSelected ? outerSize : size],
    iconAnchor: [isSelected ? outerSize/2 : size/2, isSelected ? outerSize/2 : size/2],
  });
};

function SpeciesMarker({ species, onClick, isSelected }) {
  const handleClick = () => {
    if (onClick) {
      onClick(species);
    }
  };

  // Use the taxon's location if available, otherwise use a default or random offset
  const position = species.location || [species.lat, species.lng];

  return (
    <Marker
      position={position}
      icon={getIconForCategory(species.category, isSelected)}
      eventHandlers={{
        click: handleClick,
      }}
    >
      <Popup>
        <div className="species-popup">
          <div className="popup-image">
            {species.photoUrl ? (
              <img src={species.photoUrl} alt={species.commonName} />
            ) : (
              <div className="popup-no-image">Picture not available</div>
            )}
          </div>
          <h3 className="popup-title">{species.commonName}</h3>
          <p className="popup-scientific-name">{species.scientificName}</p>
          <p className="popup-conservation-status">
            <strong>Conservation Status:</strong> {species.conservationStatusText}
          </p>
        </div>
      </Popup>
    </Marker>
  );
}

export default SpeciesMarker;
